import { create } from 'zustand';
import type { DocumentSortDirection } from '@/services/interfaces';

interface DocumentState {
  selectedDocumentId: string | null;
  filter: string;
  page: number;
  sortDirection: DocumentSortDirection;
  setSelectedDocumentId: (id: string | null) => void;
  setFilter: (filter: string) => void;
  setPage: (page: number) => void;
  setSortDirection: (sortDirection: DocumentSortDirection) => void;
}

export const useDocumentStore = create<DocumentState>((set) => ({
  selectedDocumentId: null,
  filter: 'PendingReview',
  page: 1,
  sortDirection: 'asc',
  setSelectedDocumentId: (id) => set({ selectedDocumentId: id }),
  setFilter: (filter) => set({ filter, page: 1, selectedDocumentId: null }),
  setPage: (page) => set({ page }),
  setSortDirection: (sortDirection) => set({ sortDirection, page: 1 }),
}));
